"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInstantiationIdentifier = exports.InstantiationFactory = exports.instantiationIds = void 0;
var instantiation_service_1 = require("./instantiation-service");
var registry_1 = require("./registry");
exports.instantiationIds = new Map();
// Ioc容器Id
var InstantiationIdentifierImpl = /** @class */ (function () {
    function InstantiationIdentifierImpl(id) {
        this.id = id;
    }
    InstantiationIdentifierImpl.prototype.getId = function () {
        return this.id;
    };
    return InstantiationIdentifierImpl;
}());
// Ioc容器工厂方法，用于创建多个Ioc容器
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
var InstantiationFactory = /** @class */ (function () {
    function InstantiationFactory() {
    }
    // 根据ID获取/创建Ioc容器, 传入parent参数创建级联容器
    InstantiationFactory.getInstantiation = function (identifier, parent) {
        var service = registry_1.Registry.as(identifier.getId());
        if (!service) {
            if (parent) {
                service = parent.createChild();
                registry_1.Registry.add(identifier.getId(), service);
            }
            else {
                service = new instantiation_service_1.InstantiationService();
                registry_1.Registry.add(identifier.getId(), service);
            }
        }
        return service;
    };
    return InstantiationFactory;
}());
exports.InstantiationFactory = InstantiationFactory;
/**
 * 创建一个服务ID
 * @param id
 */
function createInstantiationIdentifier(id) {
    var identifier = exports.instantiationIds.get(id);
    if (!identifier) {
        identifier = new InstantiationIdentifierImpl(id);
        exports.instantiationIds.set(id, identifier);
    }
    return identifier;
}
exports.createInstantiationIdentifier = createInstantiationIdentifier;
//# sourceMappingURL=instantiation-factory.js.map